import React, { Suspense, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { FallbackView } from '../../rbts/partials';
import { userHasRole } from '../../rbts/helpers';
import { UserModel } from '../modules/auth/models/UserModel';
import { RootState } from '../../setup';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { UsuariosPage } from '../pages/usuarios/Usuarios';
import { ConfiguracionRetiro } from '../pages/usuarios/ConfiguracionRetiro';
import { BoxDeliveryPage } from '../pages/treasury/box_delivery/BoxDelivery';
import { BoxCutPage } from '../pages/treasury/box_cut/BoxCut';
import { DonationsCreateEditPage } from '../pages/donations/DonationsAE';
import { SupplierAgreementsPage } from '../pages/shopping/supplierAgreements/SupplierAgreements';
import { SalesSupplierCreateEditPage } from '../pages/sales/Suppliers/SalesSupplierAE';
import { ConciliationPage } from '../pages/conciliation/Conciliation';
import { StarShiftPage } from '../pages/start_shift/StartShift';
import { EnlistmentPage } from '../pages/customer_service/enlistment/Enlistment';
import { RecoverBalancePage } from '../pages/customer_service/recover_balance/RecoverBalance';
import { CheckBalancePage } from '../pages/customer_service/check_balance/CheckBalance';
import { DayCutPage } from '../pages/treasury/day_cut/DayCut';
import { DayCutReportPage } from '../pages/reportes/day_cut/DayCut';
import { ProveedoresPage } from '../pages/proveedores/Proveedores';
import { EventosPage } from '../pages/eventos/Eventos';
import { ComprasDonativosReporte } from '../pages/reportes/compras_donativos/ComprasDonativosReporte';
import { ReporteVentas } from '../pages/reportes/ventas/Ventas';
import { CortesiasReporte } from '../pages/reportes/cortesias/Cortesias';
import { ConsultarMovimientos } from '../pages/customer_service/movimientos/Movimientos';
import { HistorialRecargasPage } from '../pages/customer_service/historial_recargas/HistorialRecargas';
import { ReporteCAPage } from '../pages/customer_service/reporte_cargas_abonos/ReporteCA';
import { ReporteConciliationPage } from '../pages/reportes/conciliation/ReporteConciliation';
import { ReporteRetiros } from '../pages/reportes/ReporteRetiros';
import { VentasCortesiasReporte } from '../pages/reportes/ventas_cortesias/VentasCortesias';
import { ReporteVentasPage } from '../pages/reportes/reporte_ventas/ReporteVentas';
import { RemanentePage } from '../pages/reportes/remanente/RemanentePage';
import { ReportePVPage } from '../pages/reportes/reporte_pv/ReportePVPage';
import { TicketsPage } from '../pages/tickets/Tickets';
import { TraspasosPage } from '../pages/tickets/traspaso/Traspaso';
import { VentasCortesiasTipoPage } from '../pages/reportes/ventas_cortesias_tipo/VentasCortesiasTipoPage';
import { TipoPuntoVentaPage } from '../pages/catalogos/tipo_punto_venta/TipoPuntoVenta';

export function PrivateRoutes() {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;
  const { roles: userRoles } = user;
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {/* INICIO */}
        <Route
          path="/dashboard"
          component={
            userHasRole(
              ['ADMIN', 'TESO', 'SERVCLIENTE', 'COMPRAS', 'SUPERVISOR'],
              userRoles
            )
              ? DashboardWrapper
              : ErrorsPage
          }
        />
        {/* TESORERIA */}
        <Route
          path="/tesoreria/entrega_caja"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? BoxDeliveryPage
              : ErrorsPage
          }
        />
        <Route
          path="/tesoreria/corte_caja"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles) ? BoxCutPage : ErrorsPage
          }
        />

        {/* SERVICIO CLIENTE */}
        <Route
          path="/servicio_cliente/enrolamiento"
          component={
            userHasRole(['ADMIN', 'TESO', 'SERVCLIENTE'], userRoles)
              ? EnlistmentPage
              : ErrorsPage
          }
        />
        <Route
          path="/servicio_cliente/recuperar_saldo"
          component={
            userHasRole(['ADMIN', 'TESO', 'SERVCLIENTE'], userRoles)
              ? RecoverBalancePage
              : ErrorsPage
          }
        />
        <Route
          path="/servicio_cliente/consultar_saldo"
          component={
            userHasRole(['ADMIN', 'TESO', 'SERVCLIENTE'], userRoles)
              ? CheckBalancePage
              : ErrorsPage
          }
        />
        <Route
          path="/servicio_cliente/consultar_movimientos"
          component={
            userHasRole(['ADMIN', 'TESO', 'SERVCLIENTE'], userRoles)
              ? ConsultarMovimientos
              : ErrorsPage
          }
        />
        <Route
          path="/servicio_cliente/historial_recargas"
          component={
            userHasRole(['ADMIN', 'TESO', 'SERVCLIENTE'], userRoles)
              ? HistorialRecargasPage
              : ErrorsPage
          }
        />
        <Route
          path="/servicio_cliente/reporte_cargas_abonos"
          component={
            userHasRole(['ADMIN', 'TESO', 'SERVCLIENTE'], userRoles)
              ? ReporteCAPage
              : ErrorsPage
          }
        />

        {/* COMPRAS */}

        <Route
          path="/compras/proveedores/"
          component={
            userHasRole(['ADMIN', 'COMPRAS'], userRoles)
              ? ProveedoresPage
              : ErrorsPage
          }
        />
        <Route
          path="/compras/acuerdos_proveedores/"
          component={
            userHasRole(['ADMIN', 'COMPRAS'], userRoles)
              ? SupplierAgreementsPage
              : ErrorsPage
          }
        />

        {/* COMPRAS */}

        <Route
          path="/eventos/listado_eventos/"
          component={
            userHasRole(['ADMIN'], userRoles) ? EventosPage : ErrorsPage
          }
        />

        <Route
          path="/ventas/ventas_puntos_venta/"
          component={
            userHasRole(['ADMIN', 'COMPRAS'], userRoles)
              ? SalesSupplierCreateEditPage
              : ErrorsPage
          }
        />
        <Route
          path="/ventas/puntos_venta/"
          component={
            userHasRole(['ADMIN', 'COMPRAS'], userRoles)
              ? StarShiftPage
              : ErrorsPage
          }
        />
        <Route
          path="/ventas/conciliacion/"
          component={
            userHasRole(['ADMIN', 'COMPRAS'], userRoles)
              ? ConciliationPage
              : ErrorsPage
          }
        />

        {/* DONATIVOS */}
        <Route
          path="/compras/donativos/"
          component={
            userHasRole(['ADMIN', 'COMPRAS'], userRoles)
              ? DonationsCreateEditPage
              : ErrorsPage
          }
        />

        <Route
          path="/tesoreria/cortes_dia/"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles) ? DayCutPage : ErrorsPage
          }
        />

        <Route
          path="/reportes/cortesias"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? CortesiasReporte
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/ventas"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? ReporteVentas
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/conciliacion"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? ReporteConciliationPage
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/retiros"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? ReporteRetiros
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/ventas-cortesias"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? VentasCortesiasReporte
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/remanente-tickets"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? RemanentePage
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/reporte-ventas"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? ReporteVentasPage
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/puntos-venta"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? ReportePVPage
              : ErrorsPage
          }
        />
        <Route
          path="/reportes/ventas-cortesias-tipo"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles)
              ? VentasCortesiasTipoPage
              : ErrorsPage
          }
        />
        {/* <Route
          path="/reportes/reporte_dia"
          component={
            userHasRole(['ADMIN'], userRoles) ? DayCutReportPage : ErrorsPage
          }
        /> */}

        {/* <Route
          path="/catalogos/prueba/"
          component={userHasRole(['ADMIN'], userRoles) ? TestPage : ErrorsPage}
        />
        <Route
          path="/catalogos/generico/:code"
          component={
            userHasRole(['ADMIN'], userRoles) ? GenericoPage : ErrorsPage
          }
        /> */}
        {/* TICKETS */}
        <Route
          path="/tickets/generacion_tickets"
          component={
            userHasRole(['ADMIN'], userRoles) ? TicketsPage : ErrorsPage
          }
        />
        <Route
          path="/tickets/traspaso_wallet"
          component={
            userHasRole(['ADMIN', 'TESO'], userRoles) ? TraspasosPage : ErrorsPage
          }
        />

        <Route
          path="/administracion/usuarios"
          component={
            userHasRole(['ADMIN'], userRoles) ? UsuariosPage : ErrorsPage
          }
        />
        <Route
          path="/administracion/retiros"
          component={
            userHasRole(['ADMIN'], userRoles) ? ConfiguracionRetiro : ErrorsPage
          }
        />
        {/* CATÁLOGOS */}
        <Route
          path="/catalogos/tipos_punto_venta"
          component={
            userHasRole(['ADMIN'], userRoles) ? TipoPuntoVentaPage : ErrorsPage
          }
        />
        {/* <Route
          path="/empresas"
          component={
            userHasRole(['ADMIN'], userRoles) ? EmpresasPage : ErrorsPage
          }
        />
        <Route
          path="/api_keys/"
          component={
            userHasRole(['ADMIN'], userRoles) ? ApiKeyPage : ErrorsPage
          }
        /> */}
        <Route path="/perfil" component={ProfilePage} />
        <Redirect from="/auth" to="/dashboard" />
        <Redirect exact from="/" to="/dashboard" />
        <Redirect to="/error/404" />
      </Switch>
    </Suspense>
  );
}
